import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

type ShellWidthContextValue = {
  wide: boolean;
  setWide: (wide: boolean) => void;
};

const ShellWidthContext = createContext<ShellWidthContextValue | null>(null);

export function ShellWidthProvider({ children }: { children: ReactNode }) {
  const [wide, setWideState] = useState(false);
  const setWide = useCallback((next: boolean) => {
    setWideState(next);
  }, []);
  const value = useMemo(() => ({ wide, setWide }), [wide, setWide]);
  return (
    <ShellWidthContext.Provider value={value}>
      {children}
    </ShellWidthContext.Provider>
  );
}

export function useShellWidth(): ShellWidthContextValue {
  const ctx = useContext(ShellWidthContext);
  if (!ctx) {
    throw new Error("useShellWidth must be used within ShellWidthProvider");
  }
  return ctx;
}
